import { connect } from 'react-redux';
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';
import React, { Fragment, Suspense } from 'react';
import routes from 'library/Routes';
import { serviceLocator } from 'infrastructure/ServiceLocator';
import { push } from 'react-router-redux';
import queryString from 'query-string';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import LayoutHelper from 'infrastructure/LayoutHelper';
import Autosuggest from 'react-autosuggest';
import { GoogleMapsLoader } from '../../components/Shared/GoogleMapsLoader';
import classnames from 'classnames';
import _ from 'lodash';
import StyledAutosuggestWrapper from '../../components/Form/StyledAutosuggestWrapper';
import {
  IconButton,
  SwipeableDrawer,
  Hidden,
  Link,
  Typography,
  Tooltip,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Box,
  Divider,
  Chip,
  Button,
  Icon,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  AppBar,
  Toolbar,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AddSharpIcon from '@material-ui/icons/AddSharp';
import CloseIcon from '@material-ui/icons/Close';
import Loop from '@material-ui/icons/Loop';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import FormatListBulletedOutlinedIcon from '@material-ui/icons/FormatListBulletedOutlined';
import UserHelper from 'infrastructure/UserHelper';
import { compose, withStateHandlers, lifecycle, withProps } from 'recompose';

const VooptySearchMapComponent = React.lazy(() => import('./VooptySearchMapComponent.js'));

class SearchView extends React.Component {
  constructor(props) {
    super(props);
    const pageState = window.__PAGE_STATE__;
    let seo = pageState ? pageState.seo : null;

    let location = props.location;
    let northeast = this.props.northeast;
    let southwest = this.props.southwest;
    if (seo && !location) {
      location = seo.cityLabel + ', ' + seo.countryLabel;
      const viewport = seo.viewport;
      northeast = `${viewport.northeast.lat},${viewport.northeast.lon}`;
      southwest = `${viewport.southwest.lat},${viewport.southwest.lon}`;
    }
    let category = this.props.match.params.category;
    if (!location) {
      location = this.props.persistedLocation;
    }
    this.state = {
      seo: seo,
      address: location,
      loadingItems: true,
      northeast: northeast,
      southwest: southwest,
      searchInput: this.props.keyword,
      remoteEducation: this.props.remoteEducation,
      specialNeeds: this.props.specialNeeds,
      inclusive: this.props.inclusive,
      selectedCategoryName: category ? category : this.props.categoryName,
      tutoring: this.props.tutoring,
      veteran: this.props.veteran,
      mapView: props.mapView,
      suggestions: [],
      showMobileCategories: false,
      locationDefined: true,
      from: 0,
      items: [],
      promocode: this.props.promocode,
    };
    this.onChange = this.onSearchChanged;
    this.handleSelect = this.handleSelect.bind(this);
    this.onSuggestionsUpdateRequested = debounce(this.onSuggestionsFetchRequested.bind(this), 500);
  }

  componentWillMount() {
    this.loadSeoRegions();
    if (this.state.northeast && this.state.southwest) {
      this.loadCategories();
      this.doViewPortSearch(undefined, 0);
    } else {
      if (this.state.address) {
        this.doViewPortSearchByAddress(this.state.address);
      } else {
        this.searchItems();
      }
    }
  }

  loadCategories = () => {
    let api = serviceLocator.studioApi;
    api
      .getCategoriesAgg({
        northeast: this.state.northeast,
        southwest: this.state.southwest,
        text: this.state.searchInput,
      })
      .then((agg) => {
        this.setState({ categoriesAgg: agg });
      }, LayoutHelper.onErr);
  };

  doViewPortSearchByAddress = (address) => {
    return geocodeByAddress(address)
      .then((results) => {
        let result = results[0];
        let geometry = result.geometry;
        let viewport = geometry.viewport;
        let northeast = viewport.getNorthEast().toUrlValue();
        let southwest = viewport.getSouthWest().toUrlValue();
        this.setState({
          northeast: northeast,
          southwest: southwest,
          address: result.formatted_address,
        });
        //this.props.toViewPortSearch(result.formatted_address, northeast, southwest, this.state.searchInput, this.state.mapView, this.state.selectedCategoryName, this.state.remoteEducation, this.state.tutoring);
        this.props.toViewPortSearch({
          location: result.formatted_address,
          northeast: northeast,
          southwest: southwest,
          keyword: this.state.searchInput,
          mapView: this.state.mapView,
          category: this.state.selectedCategoryName,
          remoteEducation: this.state.remoteEducation,
          tutoring: this.state.tutoring,
          veteran: this.state.veteran,
          specialNeeds: this.state.specialNeeds,
          inclusive: this.state.inclusive,
          promocode: this.state.promocode,
        });
      })
      .catch((error) => {
        console.log('Oh no!', error);
      });
  };

  onSearchChanged = (address) => {
    this.setState({ address });
    // localStorage.setItem('searchLocation', address);
  };
  onBlur = () => {
    this.handleSelect(this.state.address);
  };

  doViewPortSearch = (maxScore, from) => {
    let api = serviceLocator.searchApi;
    this.setState({ loadingItems: true });
    return api
      .getSearchResultByViewport({
        southwest: this.state.southwest,
        northeast: this.state.northeast,
        text: this.state.searchInput,
        tutoring: this.state.tutoring,
        veteran: this.state.veteran,
        remoteEducation: this.state.remoteEducation,
        specialNeeds: this.state.specialNeeds,
        inclusive: this.state.inclusive,
        promocode: this.state.promocode,
        category: this.state.selectedCategoryName,
        from: from,
      })
      .then(
        (result) => {
          let maybeItems = [];
          let newItems = [];
          let total = result.pagination.total;
          if (result.items && result.items.length > 0) {
            if (this.state.searchInput) {
              if (maxScore === undefined) {
                maxScore = result.items[0].score;
              }

              for (let i = 0; i < result.items.length; i++) {
                let item = result.items[i];
                newItems.push(item);
                // if ((maxScore / item.score) >= 3) {
                //     maybeItems.push(item);
                // } else {
                //     newItems.push(item);
                // }
              }
            } else {
              newItems = result.items;
            }
          }

          let items = this.state.items.concat(newItems);
          //maybeItems = this.state.maybeItems.concat(maybeItems);
          this.setState({
            items: items,
            loadingItems: false,
            total: total,
            maxScore: maxScore,
          });
          let loadedItems = from + 20;
          if (loadedItems < total && loadedItems < 40) {
            this.doViewPortSearch(maxScore, from + 20);
          }
        },
        (err) => {
          this.setState({
            items: [],
            loadingItems: false,
          });
        }
      );
  };
  loadSeoRegions = () => {
    this.setState({ loadingSeoRegions: true });
    const api = serviceLocator.searchApi;
    api.seoRegions(this.props.currentLanguage).then((regionsAgg) => {
      this.setState({ regionsAgg: regionsAgg, loadingSeoRegions: false });
    }, LayoutHelper.onErr);
  };

  searchItems() {
    let api = serviceLocator.searchApi;
    this.setState({ loadingItems: true });
    return api
      .getSearchResult({
        pageNumber: 1,
        pageSize: 20,
      })
      .then(
        (result) => {
          if (result.definedLocation) {
            this.state.geocodeResults = result.definedLocation;
            this.doViewPortSearchByAddress(result.definedLocation.city + ', ' + result.definedLocation.country);
          } else {
            this.setState({ locationDefined: false });
          }
          this.setState({
            items: result.items,
            loadingItems: false,
          });
        },
        (err) => {
          console.log(err);
          this.setState({
            items: [],
            loadingItems: false,
          });
        }
      );
  }

  seoSearch(country, city) {
    let api = serviceLocator.searchApi;
    this.setState({ loadingItems: true });
    return api
      .getSeoSearchResult({
        country: country,
        city: city,
        category: this.state.selectedCategoryName,
      })
      .then(
        (result) => {
          this.setState({
            items: result.items,
            loadingItems: false,
          });
        },
        (err) => {
          console.log(err);
          this.setState({
            items: [],
            loadingItems: false,
          });
        }
      );
  }

  handleSearchClick = (e) => {
    let searchInput = this.state.searchInput ? this.state.searchInput : undefined;
    if (this.state.northeast && this.state.southwest) {
      //this.props.toViewPortSearch(this.state.address, this.state.northeast, this.state.southwest, searchInput, this.state.mapView, this.state.selectedCategoryName, this.state.remoteEducation, this.state.tutoring);
      this.props.toViewPortSearch({
        location: this.state.address,
        northeast: this.state.northeast,
        southwest: this.state.southwest,
        keyword: searchInput,
        mapView: this.state.mapView,
        category: this.state.selectedCategoryName,
        remoteEducation: this.state.remoteEducation,
        tutoring: this.state.tutoring,
        veteran: this.state.veteran,
        specialNeeds: this.state.specialNeeds,
        inclusive: this.state.inclusive,
        promocode: this.state.promocode,
      });
    } else {
      this.doViewPortSearchByAddress(this.state.address);
    }
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.which === 13) {
      e.preventDefault();
      this.handleSearchClick(e);
    }
  };

  handleSelect(address) {
    this.setState({
      address,
      loading: true,
    });

    geocodeByAddress(address)
      .then((results) => {
        let result = results[0];
        let geometry = result.geometry;
        let viewport = geometry.viewport;
        let northeast = viewport.getNorthEast().toUrlValue();
        let southwest = viewport.getSouthWest().toUrlValue();
        this.setState({
          northeast: northeast,
          southwest: southwest,
          address: result.formatted_address,
        });
        localStorage.setItem('searchLocation', result.formatted_address);
        this.props.toViewPortSearch({
          location: result.formatted_address,
          northeast: northeast,
          southwest: southwest,
          keyword: this.state.searchInput,
          mapView: this.state.mapView,
          category: this.state.selectedCategoryName,
          remoteEducation: this.state.remoteEducation,
          tutoring: this.state.tutoring,
          veteran: this.state.veteran,
          specialNeeds: this.state.specialNeeds,
          inclusive: this.props.inclusive,
        });
        //this.props.toViewPortSearch(result.formatted_address, northeast, southwest, this.state.searchInput, this.state.mapView, this.state.selectedCategoryName, this.state.remoteEducation, this.state.tutoring);
        // return getLatLng(result)
      })
      // .then(({lat, lng}) => {
      //     console.log('Success Yay', {lat, lng})
      //     this.setState({
      //         geocodeResults: {lat: lat, lng: lng},
      //         loading: false
      //     })
      //     this.handleSearchClick();
      // })
      .catch((error) => {
        console.log('Oh no!', error);
      });
  }

  renderSearchItem = (item) => {
    const style = {};
    if (item.hasPormocode) {
      style.border = 'solid 1px #feb422';
    }
    return (
      <Grid item xs={12} sm={6} md={4}>
        <Link
          href={routes.studio({ domainName: item.domainName })}
          rel={!item.managedByVoopty && 'nofollow'}
          target="_blank"
        >
          <Card className={this.props.classes.itemCard} style={style}>
            <CardActionArea component="div" className={this.props.classes.cardArea} key={item.id}>
              {this.renderAvatar(item)}
              <CardContent className={this.props.classes.cardContent}>
                {this.renderRating(item)}
                <Typography gutterBottom variant="subtitle2" component="h3">
                  {item.name}
                </Typography>
                <div className={this.props.classes.address}>
                  <LocationOnOutlinedIcon />
                  <Typography variant="body2" color="textSecondary" component="span">
                    {item.address}
                  </Typography>
                </div>
              </CardContent>
              <ul className={this.props.classes.infoIcons}>
                {this.renderSpecialNeeds(item.specialNeeds)}
                {this.renderInclusive(item.inclusive)}
                {this.renderRemoteEducation(item.remoteEducation)}
                {this.renderTutoring(item.tutoring)}
                {/*{this.renderVeteran(item.veteran)}*/}
              </ul>
              <ul className={this.props.classes.promoIcons}>
                {this.renderPromocode(item)}
                {this.renderVideoReview(item.videoReview)}
              </ul>
            </CardActionArea>
          </Card>
        </Link>
      </Grid>
    );
  };
  renderRating = (studio) => {
    if (studio.ratingValue) {
      return (
        <div className={this.props.classes.headerRate}>
          <strong className={this.props.classes.ratingValue}>{Math.round(studio.ratingValue * 10) / 10}</strong> /
          <span>{this.renderRatingLabel(studio.ratingValue)}</span>
        </div>
      );
    }
  };
  renderRatingLabel = (ratingValue) => {
    if (ratingValue > 4) {
      return this.props.translate('studio.review.great');
    }
    if (ratingValue > 3) {
      return this.props.translate('studio.review.good');
    }
    if (ratingValue > 2) {
      return this.props.translate('studio.review.ok');
    }
    if (ratingValue > 1) {
      return this.props.translate('studio.review.notGood');
    }
    return this.props.translate('studio.review.bad');
  };
  renderAvatar = (studio) => {
    if (studio.avatar) {
      return (
        <Fragment>
          <CardMedia
            data-bgset={studio.avatar}
            title={studio.name}
            alt={studio.name}
            className={classnames('lazyload', this.props.classes.media)}
          />
        </Fragment>
      );
    }
  };

  renderTutoring = (tutoring) => {
    if (tutoring) {
      return (
        <Tooltip title={this.props.translate('studio.tutoring')}>
          <li>
            <Icon className={this.props.classes.icon}>
              <img
                alt={this.props.translate('studio.tutoring')}
                src={`${this.props.domain.staticUrl}/professor.svg`}
                height={28}
                width={28}
              />
            </Icon>
          </li>
        </Tooltip>
      );
    }
  };
  renderVideoReview = (videoReview) => {
    if (videoReview) {
      return (
        <Tooltip title={this.props.translate('studio.videoReview')}>
          <li className="youtube" />
        </Tooltip>
      );
    }
  };
  renderPromocode = (item) => {
    if (item.hasPormocode) {
      return (
        <Tooltip title={this.props.translate('studio.promocode')}>
          <li>
            <Icon className={this.props.classes.icon}>
              <img
                alt={this.props.translate('studio.promocode')}
                src={`${this.props.domain.staticUrl}/percentage.svg`}
                height={28}
                width={28}
              />
            </Icon>
          </li>
        </Tooltip>
      );
    }
  };
  renderRemoteEducation = (remoteEducation) => {
    if (remoteEducation) {
      return (
        <Tooltip title={this.props.translate('studio.remoteEducation')}>
          <li>
            <Icon className={this.props.classes.icon}>
              <img
                alt={this.props.translate('studio.remoteEducation')}
                src={`${this.props.domain.staticUrl}/worldwide.svg`}
                height={28}
                width={28}
              />
            </Icon>
          </li>
        </Tooltip>
      );
    }
  };
  renderSpecialNeeds = (specialNeeds) => {
    if (specialNeeds) {
      return (
        <Tooltip title={this.props.translate('studio.specialNeeds')}>
          <li>
            <Icon className={this.props.classes.icon}>
              <img
                alt={this.props.translate('studio.specialNeeds')}
                src={`${this.props.domain.staticUrl}/wheelchair.svg`}
                height={28}
                width={28}
              />
            </Icon>
          </li>
        </Tooltip>
      );
    }
  };
  renderInclusive = (inclusive) => {
    if (inclusive) {
      return (
        <Tooltip title={this.props.translate('studio.inclusive')}>
          <li>
            <Icon className={this.props.classes.icon}>
              <img
                alt={this.props.translate('studio.inclusive')}
                src={`${this.props.domain.staticUrl}/creative.svg`}
                height={28}
                width={28}
              />
            </Icon>
          </li>
        </Tooltip>
      );
    }
  };
  renderAutocomplete = () => {
    const inputProps = {
      type: 'text',
      value: this.state.address,
      onChange: this.onChange,
      onBlur: this.onBlur,
      autoFocus: false,
      onFocus: () => {
        this.setState({ address: '' });
      },
      placeholder: this.props.translate('search.searchLocationHint'),
      name: 'search-location',
      id: 'places-autocomplete',
    };

    return (
      <Typography component="div" className={this.props.classes.placesTypography}>
        <PlacesAutocomplete
          inputProps={inputProps}
          onSelect={this.handleSelect}
          onEnterKeyDown={this.handleSelect}
          onError={(status, clearSuggestions) => {
            console.log('Google Maps API returned error with status: ', status);
            clearSuggestions();
          }}
        />
      </Typography>
    );
  };

  render() {
    const { keyword, location, translate, currentLanguage } = this.props;
    const inputProps = {
      placeholder: translate('search.searchHint'),
      value: this.state.searchInput,
      onChange: this.onKeywordChange,
      className: this.props.classes.searchInput,
      onKeyPress: this.handleKeyPress,
      defaultValue: this.props.keyword,
      onFocus: () => {
        this.setState({ searchInput: '' });
        this.onSuggestionsClearRequested();
      },
    };

    if (this.state.locationDefined) {
      return (
        <div className={this.props.classes.wrapper}>
          <Grid className={this.props.classes.searchArea} container spacing={2} alignItems="center">
            <Grid item xs={12} sm={5}>
              <StyledAutosuggestWrapper>
                <Autosuggest
                  focusInputOnSuggestionClick={LayoutHelper.isMobile()}
                  suggestions={this.state.suggestions}
                  onSuggestionsFetchRequested={this.onSuggestionsUpdateRequested}
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  getSuggestionValue={this.getSuggestionValue}
                  renderSuggestion={this.renderSuggestion}
                  inputProps={inputProps}
                  onSuggestionSelected={(e, { suggestion }) => {
                    this.setState({
                      searchInput: suggestion,
                    });
                  }}
                />
              </StyledAutosuggestWrapper>
              {this.state.isLoadingSuggestions && (
                <div style={{ position: 'relative' }}>
                  <div
                    style={{
                      right: '15px',
                      position: 'absolute',
                      top: '-40px',
                    }}
                  >
                    {LayoutHelper.renderLoader()}
                  </div>
                </div>
              )}
            </Grid>
            <Grid item xs={9} sm={5}>
              {this.renderAutocomplete()}
            </Grid>
            <Grid item xs={3} sm={2}>
              <Button fullWidth variant="contained" color="primary" onClick={this.handleSearchClick}>
                {translate('common.search')}
              </Button>
            </Grid>
          </Grid>
          <div className={this.props.classes.section}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={3}>
                {this.renderCategories()}
              </Grid>
              <Grid item xs={12} md={9}>
                <div className={this.props.classes.viewChangeArea}>{this.renderViewChange()}</div>
                <Grid container spacing={2}>
                  {this.renderResults()}
                  {this.state.items && this.state.total > this.state.items.length && (
                    <Grid item xs={12}>
                      <Button
                        color="primary"
                        variant="outlined"
                        fullWidth
                        onClick={() => {
                          this.doViewPortSearch(this.state.maxScore, this.state.items.length);
                        }}
                      >
                        <Loop />
                        {translate('common.more')}
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </div>
          <Divider />
          <div className={this.props.classes.sectionRegions}>{this.renderSeoRegions()}</div>
        </div>
      );
    } else {
      return (
        <Grid className={this.props.classes.container} container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" component="h3" align="center">
              {this.props.translate('search.locationIsUndefined')}
            </Typography>
          </Grid>
          <Grid item xs={9}>
            {this.renderAutocomplete()}
          </Grid>
          <Grid item xs={3}>
            <Button fullWidth variant="contained" color="primary" onClick={this.handleSearchClick}>
              {translate('common.search')}
            </Button>
          </Grid>
        </Grid>
      );
    }
  }

  renderCategories = () => {
    if (this.state.categoriesAgg) {
      return (
        <div>
          <Box className={this.props.classes.filtersArea} display={{ xs: 'block', md: 'none' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                this.setState({
                  showMobileCategories: !this.state.showMobileCategories,
                });
              }}
            >
              {this.props.translate('search.filter')}
            </Button>
            {this.renderSelectedFilters()}
          </Box>
          {this.renderMobileCategories()}
          <Hidden smDown>
            <Box style={{ display: 'block' }}>
              <div className={this.props.classes.filtersArea}>{this.renderSelectedFilters()}</div>
              <div className={this.props.classes.navCategory}>
                {this.state.categoriesAgg.map((category) => this.renderCategoryAgg(category))}
              </div>
              <div className={this.props.classes.infoiconsHolder}>
                <div className={this.props.classes.infoiconItem}>
                  <input
                    id="check-remote"
                    type="checkbox"
                    defaultChecked={this.state.remoteEducation}
                    onChange={this.changeRemoteEducation}
                  />
                  <label htmlFor="check-remote">
                    <Icon className={this.props.classes.icon}>
                      <img
                        alt={this.props.translate('studio.remoteEducation')}
                        src={`${this.props.domain.staticUrl}/worldwide.svg`}
                        height={28}
                        width={28}
                      />
                    </Icon>
                    {this.props.translate('studio.remoteEducation')}
                  </label>
                </div>

                <div className={this.props.classes.infoiconItem}>
                  <input
                    id="check-tutoring"
                    type="checkbox"
                    defaultChecked={this.state.tutoring}
                    onChange={this.changeTutoring}
                  />
                  <label htmlFor="check-tutoring">
                    <Icon className={this.props.classes.icon}>
                      <img
                        alt={this.props.translate('studio.tutoring')}
                        src={`${this.props.domain.staticUrl}/professor.svg`}
                        height={28}
                        width={28}
                      />
                    </Icon>
                    {this.props.translate('studio.tutoring')}
                  </label>
                </div>

                <div className={this.props.classes.infoiconItem}>
                  <input
                    id="check-specialNeeds"
                    type="checkbox"
                    defaultChecked={this.state.specialNeeds}
                    onChange={this.changeSpecialNeeds}
                  />
                  <label htmlFor="check-specialNeeds">
                    <Icon className={this.props.classes.icon}>
                      <img
                        alt={this.props.translate('studio.specialNeeds')}
                        src={`${this.props.domain.staticUrl}/wheelchair.svg`}
                        height={28}
                        width={28}
                      />
                    </Icon>
                    {this.props.translate('studio.specialNeeds')}
                  </label>
                </div>
                <div className={this.props.classes.infoiconItem}>
                  <input
                    id="check-inclusive"
                    type="checkbox"
                    defaultChecked={this.state.inclusive}
                    onChange={this.changeInclusive}
                  />

                  <label htmlFor="check-inclusive">
                    <Icon className={this.props.classes.icon}>
                      <img
                        alt={this.props.translate('studio.inclusive')}
                        src={`${this.props.domain.staticUrl}/creative.svg`}
                        height={28}
                        width={28}
                      />
                    </Icon>
                    {this.props.translate('studio.inclusive')}
                  </label>
                </div>
                <div className={this.props.classes.infoiconItem}>
                  <input
                    id="check-promocode"
                    type="checkbox"
                    defaultChecked={this.state.promocode}
                    onChange={this.changePromocode}
                  />

                  <label htmlFor="check-promocode">
                    <Icon className={this.props.classes.icon}>
                      <img
                        alt={this.props.translate('studio.withPromocode')}
                        src={`${this.props.domain.staticUrl}/percentage.svg`}
                        height={28}
                        width={28}
                      />
                    </Icon>
                    {this.props.translate('studio.withPromocode')}
                  </label>
                  {!UserHelper.isLoggedIn(this.props.user) && (
                    <Typography className={this.props.classes.noteSm} color="textSecondary">
                      {<Link href={routes.clientLogin()}>{this.props.translate('studio.promocodeSignIn')}</Link>}
                      {this.props.translate('studio.promocodeCTA')}
                    </Typography>
                  )}
                </div>
              </div>
            </Box>
          </Hidden>
        </div>
      );
    }
  };
  renderMobileCategories = () => {
    // if (this.state.showMobileCategories) {
    return (
      <Hidden mdUp>
        <SwipeableDrawer
          variant="temporary"
          anchor="left"
          onClose={() => {
            this.setState({ showMobileCategories: false });
          }}
          classes={{
            paper: this.props.classes.drawerPaper,
          }}
          open={this.state.showMobileCategories}
        >
          <AppBar position="static" color="default" className={this.props.classes.tabs}>
            <Toolbar>
              <IconButton
                color="inherit"
                onClick={() => {
                  this.setState({ showMobileCategories: false });
                }}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={this.props.classes.flex}>
                {this.props.translate('common.filter')}
              </Typography>
            </Toolbar>
          </AppBar>

          <div>
            <div className={this.props.classes.navCategory}>
              {this.state.categoriesAgg.map((category) => this.renderCategoryAgg(category))}
            </div>
            <div className={this.props.classes.infoiconsHolder}>
              <div className={this.props.classes.infoiconItem}>
                <input
                  id="check-remote"
                  type="checkbox"
                  defaultChecked={this.state.remoteEducation}
                  onChange={this.changeRemoteEducation}
                />
                <label htmlFor="check-remote">
                  <Icon className={this.props.classes.icon}>
                    <img
                      alt={this.props.translate('studio.remoteEducation')}
                      src={`${this.props.domain.staticUrl}/worldwide.svg`}
                      height={28}
                      width={28}
                    />
                  </Icon>
                  {this.props.translate('studio.remoteEducation')}
                </label>
              </div>
              <div className={this.props.classes.infoiconItem}>
                <input
                  id="check-tutoring"
                  type="checkbox"
                  defaultChecked={this.state.tutoring}
                  onChange={this.changeTutoring}
                />
                <label htmlFor="check-tutoring">
                  <Icon className={this.props.classes.icon}>
                    <img
                      alt={this.props.translate('studio.tutoring')}
                      src={`${this.props.domain.staticUrl}/professor.svg`}
                      height={28}
                      width={28}
                    />
                  </Icon>
                  {this.props.translate('studio.tutoring')}
                </label>
              </div>
              <div className={this.props.classes.infoiconItem}>
                <input
                  id="check-specialNeeds"
                  type="checkbox"
                  defaultChecked={this.state.specialNeeds}
                  onChange={this.changeSpecialNeeds}
                />

                <label htmlFor="check-specialNeeds">
                  <Icon className={this.props.classes.icon}>
                    <img
                      alt={this.props.translate('studio.specialNeeds')}
                      src={`${this.props.domain.staticUrl}/wheelchair.svg`}
                      height={28}
                      width={28}
                    />
                  </Icon>
                  {this.props.translate('studio.specialNeeds')}
                </label>
              </div>
              <div className={this.props.classes.infoiconItem}>
                <input
                  id="check-inclusive"
                  type="checkbox"
                  defaultChecked={this.state.inclusive}
                  onChange={this.changeInclusive}
                />

                <label htmlFor="check-inclusive">
                  <Icon className={this.props.classes.icon}>
                    <img
                      alt={this.props.translate('studio.inclusive')}
                      src={`${this.props.domain.staticUrl}/creative.svg`}
                      height={28}
                      width={28}
                    />
                  </Icon>
                  {this.props.translate('studio.inclusive')}
                </label>
              </div>
              <div className={this.props.classes.infoiconItem}>
                <input
                  id="check-promocode"
                  type="checkbox"
                  defaultChecked={this.state.promocode}
                  onChange={this.changePromocode}
                />
                <label htmlFor="check-promocode">
                  <Icon className={this.props.classes.icon}>
                    <img
                      alt={this.props.translate('studio.promocode')}
                      src={`${this.props.domain.staticUrl}/percentage.svg`}
                      height={28}
                      width={28}
                    />
                  </Icon>
                  {this.props.translate('studio.promocode')}
                </label>
                {!UserHelper.isLoggedIn(this.props.user) && (
                  <Typography className={this.props.classes.noteSm} color="textSecondary">
                    {<Link href={routes.clientLogin()}>{this.props.translate('studio.promocodeSignIn')}</Link>}
                    {this.props.translate('studio.promocodeCTA')}
                  </Typography>
                )}
              </div>
            </div>
          </div>
        </SwipeableDrawer>
      </Hidden>
    );
    // }
  };
  changeRemoteEducation = (event) => {
    let remoteEducation = event.target.checked;
    this.setState({ remoteEducation: remoteEducation });
    this.props.toViewPortSearch({
      location: this.state.address,
      northeast: this.state.northeast,
      southwest: this.state.southwest,
      keyword: this.state.searchInput,
      mapView: this.state.mapView,
      category: this.state.selectedCategoryName,
      remoteEducation: remoteEducation,
      tutoring: this.state.tutoring,
      veteran: this.state.veteran,
      promocode: this.state.promocode,
    });
  };
  changeTutoring = (event) => {
    let tutoring = event.target.checked;
    this.setState({ tutoring: tutoring });
    this.props.toViewPortSearch({
      location: this.state.address,
      northeast: this.state.northeast,
      southwest: this.state.southwest,
      keyword: this.state.searchInput,
      mapView: this.state.mapView,
      category: this.state.selectedCategoryName,
      remoteEducation: this.state.remoteEducation,
      tutoring: tutoring,
      veteran: this.state.veteran,
      promocode: this.state.promocode,
    });
    //this.props.toViewPortSearch(this.state.address, this.state.northeast, this.state.southwest, this.state.searchInput, this.state.mapView, this.state.selectedCategoryName, this.state.remoteEducation, tutoring);
  };
  changeSpecialNeeds = (event) => {
    let specialNeeds = event.target.checked;
    this.setState({ specialNeeds: specialNeeds });
    this.props.toViewPortSearch({
      location: this.state.address,
      northeast: this.state.northeast,
      southwest: this.state.southwest,
      keyword: this.state.searchInput,
      mapView: this.state.mapView,
      category: this.state.selectedCategoryName,
      remoteEducation: this.state.remoteEducation,
      tutoring: this.state.tutoring,
      specialNeeds: specialNeeds,
      inclusive: this.state.inclusive,
      veteran: this.state.veteran,
      promocode: this.state.promocode,
    });
    //this.props.toViewPortSearch(this.state.address, this.state.northeast, this.state.southwest, this.state.searchInput, this.state.mapView, this.state.selectedCategoryName, this.state.remoteEducation, this.state.tutoring, specialNeeds);
  };
  changeInclusive = (event) => {
    let inclusive = event.target.checked;
    this.setState({ inclusive: inclusive });
    this.props.toViewPortSearch({
      location: this.state.address,
      northeast: this.state.northeast,
      southwest: this.state.southwest,
      keyword: this.state.searchInput,
      mapView: this.state.mapView,
      category: this.state.selectedCategoryName,
      remoteEducation: this.state.remoteEducation,
      tutoring: this.state.tutoring,
      specialNeeds: this.state.specialNeeds,
      inclusive: inclusive,
      veteran: this.state.veteran,
      promocode: this.state.promocode,
    });
    //this.props.toViewPortSearch(this.state.address, this.state.northeast, this.state.southwest, this.state.searchInput, this.state.mapView, this.state.selectedCategoryName, this.state.remoteEducation, this.state.tutoring, specialNeeds);
  };
  changeVeteran = (event) => {
    let veteran = event.target.checked;
    this.setState({ veteran: veteran });
    this.props.toViewPortSearch({
      location: this.state.address,
      northeast: this.state.northeast,
      southwest: this.state.southwest,
      keyword: this.state.searchInput,
      mapView: this.state.mapView,
      category: this.state.selectedCategoryName,
      remoteEducation: this.state.remoteEducation,
      tutoring: this.state.tutoring,
      specialNeeds: this.state.specialNeeds,
      inclusive: this.state.inclusive,
      veteran: veteran,
      promocode: this.state.promocode,
    });
  };
  changePromocode = (event) => {
    let promocode = event.target.checked;
    this.setState({ promocode: promocode });
    this.props.toViewPortSearch({
      location: this.state.address,
      northeast: this.state.northeast,
      southwest: this.state.southwest,
      keyword: this.state.searchInput,
      mapView: this.state.mapView,
      category: this.state.selectedCategoryName,
      remoteEducation: this.state.remoteEducation,
      tutoring: this.state.tutoring,
      specialNeeds: this.state.specialNeeds,
      inclusive: this.state.inclusive,
      veteran: this.state.veteran,
      promocode: promocode,
    });
  };
  renderCategoryAgg = (superCategoryAgg) => {
    return (
      <Fragment>
        <List disablePadding={true} component="nav">
          {this.renderSuperCategory(superCategoryAgg)}
          <List disablePadding={true} component="nav">
            {superCategoryAgg.categories.map((category) => this.renderCategory(category))}
          </List>
        </List>
      </Fragment>
    );
  };

  renderCategory = (category) => {
    if (category.name === this.state.selectedCategoryName) {
      return (
        <ListItem className={category.name} button>
          <ListItemIcon>
            <AddSharpIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <React.Fragment>
                <Typography component="span" variant="body2" color="textPrimary">
                  {this.props.translate('studio.category.' + category.name)}{' '}
                </Typography>
              </React.Fragment>
            }
            secondary={
              <Typography component="span" variant="body2" color="textSecondary">
                ({category.count})
              </Typography>
            }
          />
        </ListItem>
      );
    } else {
      return (
        <ListItem
          className={category.name}
          button
          onClick={() => {
            this.handleCategorySelect(category.name);
          }}
        >
          <ListItemIcon>
            <AddSharpIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <React.Fragment>
                <Typography component="span" variant="body2" color="textPrimary">
                  {this.props.translate('studio.category.' + category.name)}{' '}
                </Typography>
              </React.Fragment>
            }
            secondary={
              <Typography component="span" variant="body2" color="textSecondary">
                ({category.count})
              </Typography>
            }
          />
        </ListItem>
      );
    }
  };

  renderAllCategories = (category) => {
    return <div>{this.renderSelectedFilters()}</div>;
  };
  renderSelectedFilters = () => {
    let selectedFilters = [];
    if (this.state.selectedCategoryName) {
      selectedFilters.push({
        key: 'category',
        label: this.props.translate('studio.category.' + this.state.selectedCategoryName),
        value: this.state.selectedCategoryName,
      });
    }
    if (this.state.specialNeeds) {
      selectedFilters.push({
        icon: (
          <img
            src={`${this.props.domain.staticUrl}/wheelchair.svg`}
            alt={this.props.translate('studio.specialNeeds')}
            height={28}
            width={28}
          />
        ),
        key: 'specialNeeds',
        label: this.props.translate('studio.specialNeeds'),
        value: true,
      });
    }
    if (this.state.inclusive) {
      selectedFilters.push({
        key: 'inclusive',
        icon: (
          <img
            src={`${this.props.domain.staticUrl}/creative.svg`}
            alt={this.props.translate('studio.inclusive')}
            height={28}
            width={28}
          />
        ),
        label: this.props.translate('studio.inclusive'),
        value: true,
      });
    }
    if (this.state.tutoring) {
      selectedFilters.push({
        key: 'tutoring',
        icon: (
          <img
            src={`${this.props.domain.staticUrl}/professor.svg`}
            alt={this.props.translate('studio.tutoring')}
            height={28}
            width={28}
          />
        ),
        label: this.props.translate('studio.tutoring'),
        value: true,
      });
    }
    if (this.state.remoteEducation) {
      selectedFilters.push({
        key: 'remoteEducation',
        icon: (
          <img
            src={`${this.props.domain.staticUrl}/worldwide.svg`}
            alt={this.props.translate('studio.remoteEducation')}
            height={28}
            width={28}
          />
        ),
        label: this.props.translate('studio.remoteEducation'),
        value: true,
      });
    }
    if (this.state.veteran) {
      selectedFilters.push({
        key: 'veteran',
        label: this.props.translate('studio.veteran'),
        value: true,
      });
    }
    if (this.state.promocode) {
      selectedFilters.push({
        icon: (
          <img
            alt={this.props.translate('studio.promocode')}
            src={`${this.props.domain.staticUrl}/percentage.svg`}
            height={28}
            width={28}
          />
        ),
        key: 'promocode',
        label: this.props.translate('studio.promocode'),
        value: true,
      });
    }
    return selectedFilters.map((item, index) => {
      return (
        <Chip
          label={item.label}
          icon={item.icon}
          color="primary"
          onDelete={() => {
            selectedFilters.splice(index, 1);
            this.handleFilterChange(selectedFilters);
          }}
        />
      );
    });
  };
  handleFilterChange = (tags) => {
    let filetrsMap = {};
    for (let i = 0; i < tags.length; i++) {
      let filterItem = tags[i];
      filetrsMap[filterItem.key] = filterItem.value;
    }

    return this.props.toViewPortSearch({
      location: this.state.address,
      northeast: this.state.northeast,
      southwest: this.state.southwest,
      keyword: this.state.searchInput,
      mapView: this.state.mapView,
      category: filetrsMap.category,
      remoteEducation: filetrsMap.remoteEducation,
      tutoring: filetrsMap.tutoring,
      specialNeeds: filetrsMap.specialNeeds,
      inclusive: filetrsMap.inclusive,
    });
  };
  renderSuperCategory = (category) => {
    if (category.name === this.state.selectedCategoryName) {
      return (
        <ListItem className={category.name} button>
          <ListItemText primary={this.props.translate('studio.category.' + category.name)} />
        </ListItem>
      );
    } else {
      return (
        <ListItem
          className={category.name}
          button
          onClick={() => {
            this.handleCategorySelect(category.name);
          }}
        >
          <ListItemText primary={this.props.translate('studio.category.' + category.name)} />
        </ListItem>
      );
    }
  };
  handleCategorySelect = (category) => {
    this.props.toViewPortSearch({
      location: this.state.address,
      northeast: this.state.northeast,
      southwest: this.state.southwest,
      keyword: this.state.searchInput,
      mapView: this.state.mapView,
      category: category,
      remoteEducation: this.state.remoteEducation,
      tutoring: this.state.tutoring,
      specialNeeds: this.state.specialNeeds,
      inclusive: this.state.inclusive,
    });
    //this.props.toViewPortSearch(this.state.address, this.state.northeast, this.state.southwest, this.state.searchInput, this.state.mapView, category, this.state.remoteEducation, this.state.tutoring);
  };

  renderViewChange = () => {
    return (
      <Fragment>
        <Button
          onClick={() => {
            this.setState({ mapView: false });
          }}
          active={!this.state.mapView}
        >
          <FormatListBulletedOutlinedIcon /> {this.props.translate('common.toGridView')}
        </Button>
        <Button
          onClick={() => {
            this.setState({ mapView: true });
          }}
          active={this.state.mapView}
        >
          <LocationOnOutlinedIcon /> {this.props.translate('common.toMapView')}
        </Button>
      </Fragment>
    );
  };

  renderMap = () => {
    if (this.state.loadingItems) {
      return LayoutHelper.renderLoader();
    } else {
      let northeast = this.state.northeast;
      let southwest = this.state.southwest;
      if (northeast && southwest) {
        let northeastLatLng = {
          lat: parseFloat(northeast.split(',')[0]),
          lng: parseFloat(northeast.split(',')[1]),
        };
        let southwestLatLng = {
          lat: parseFloat(southwest.split(',')[0]),
          lng: parseFloat(southwest.split(',')[1]),
        };

        let lat = (southwestLatLng.lat + northeastLatLng.lat) / 2;
        let lng = (southwestLatLng.lng + northeastLatLng.lng) / 2;

        return (
          <Grid item xs={12}>
            <Suspense fallback={LayoutHelper.renderLoader()}>
              <VooptySearchMapComponent
                center={{ lat: lat, lng: lng }}
                studios={this.state.items}
                onMarkerClick={(item) => {
                  item.hideMarker = false;
                }}
                onMarkerClose={(item) => {
                  console.log(item);
                }}
                containerElement={<div style={{ height: `calc(100vh - 200px)`, width: '100%' }} />}
                mapElement={<div style={{ height: `100%` }} />}
              />
            </Suspense>
          </Grid>
        );
      }
    }
  };
  onSuggestionsFetchRequested = (data) => {
    const { value } = data;
    if (value && value.trim().length !== 0) {
      let api = serviceLocator.searchApi;
      this.setState({
        isLoadingSuggestions: true,
      });
      return api.suggest(value).then((result) => {
        this.setState({
          isLoadingSuggestions: false,
          suggestions: result,
        });
      }, LayoutHelper.onErr);
    } else {
      this.setState({
        isLoadingSuggestions: false,
        suggestions: [],
      });
    }
  };
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  getSuggestionValue = (suggestion) => {
    return suggestion;
  };
  renderSuggestion = (suggestion) => {
    return <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>{suggestion}</div>;
  };

  onKeywordChange = (event, { newValue }) => {
    this.setState({
      searchInput: newValue,
    });
  };

  renderResults = () => {
    // if (this.state.loadingItems) {
    //     return LayoutHelper.renderLoader();
    // } else {
    if (!this.state.mapView) {
      if (this.state.items && this.state.items.length > 0) {
        return this.state.items.map((item) => this.renderSearchItem(item));
      } else {
        if (this.state.loadingItems) {
          return LayoutHelper.renderLoader();
        } else {
          return this.renderEmptyResults();
        }
      }
    } else {
      return this.renderMap();
    }
    // }
  };
  renderCards = () => {
    return;
  };
  renderEmptyResults = () => {
    return <span>{this.props.translate('search.noResults')}</span>;
  };
  renderSeoRegions = () => {
    if (this.state.loadingSeoRegions) {
      return LayoutHelper.renderLoader();
    }
    if (this.state.regionsAgg) {
      return (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h5">{this.props.translate('search.trySeoRegions')}</Typography>
            <br />
            {this.state.regionsAgg.map((countryAgg) => {
              const country = countryAgg.country;
              return (
                <div className={this.props.classes.regions}>
                  <Typography component="strong">
                    <LocationOnOutlinedIcon /> {country ? country.labels[this.props.currentLanguage] : countryAgg._id}:
                  </Typography>
                  <ul>
                    {countryAgg.cities.map((city) => {
                      return (
                        <li>
                          <Link
                            href={routes.seoSearch({
                              country: country.name,
                              city: city.name,
                            })}
                          >
                            {city.labels[this.props.currentLanguage]}
                          </Link>
                          <span>&bull;</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </Grid>
        </Grid>
      );
    }
  };
}

function mapStateToProps(state, ownProps) {
  let keyword = queryString.parse(ownProps.location.search).keyword || '';
  let tutoring = queryString.parse(ownProps.location.search).tutoring;
  let remoteEducation = queryString.parse(ownProps.location.search).remoteEducation;
  let specialNeeds = queryString.parse(ownProps.location.search).specialNeeds;
  let inclusive = queryString.parse(ownProps.location.search).inclusive;
  let mapView = queryString.parse(ownProps.location.search).mapView == 'true';
  let northeast = queryString.parse(ownProps.location.search).northeast;
  let southwest = queryString.parse(ownProps.location.search).southwest;
  let categoryName = queryString.parse(ownProps.location.search).category;
  let location = queryString.parse(ownProps.location.search).location;
  let veteran = queryString.parse(ownProps.location.search).veteran;
  const promocode =
    queryString.parse(ownProps.location.search).promocode || ownProps.location.pathname.includes('/promocode');
  let persistedLocation;
  try {
    persistedLocation = localStorage.getItem('searchLocation');
  } catch (e) {
    console.error(e);
  }
  let translate = getTranslate(state.locale);
  let currentLanguage = getActiveLanguage(state.locale).code;
  let domain = state.domain;

  return {
    keyword,
    location,
    northeast,
    southwest,
    persistedLocation,
    translate,
    currentLanguage,
    domain,
    mapView,
    tutoring,
    remoteEducation,
    specialNeeds,
    inclusive,
    categoryName,
    veteran,
    promocode,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    toViewPortSearch: (params) => {
      let url = `${routes.search()}?location=${params.location}&northeast=${params.northeast}&southwest=${
        params.southwest
      }&mapView=${params.mapView}`;
      if (params.keyword) {
        url += `&keyword=${params.keyword}`;
      }
      if (params.category) {
        url += `&category=${params.category}`;
      }
      if (params.remoteEducation) {
        url += `&remoteEducation=${params.remoteEducation}`;
      }
      if (params.tutoring) {
        url += `&tutoring=${params.tutoring}`;
      }
      if (params.specialNeeds) {
        url += `&specialNeeds=${params.specialNeeds}`;
      }
      if (params.inclusive) {
        url += `&inclusive=${params.inclusive}`;
      }
      if (params.veteran) {
        url += `&veteran=${params.veteran}`;
      }
      if (params.promocode) {
        url += `&promocode=${params.promocode}`;
      }
      dispatch(push(url));
    },
    toStudio: (studio) => {
      dispatch(push(routes.studio({ domainName: studio.domainName })));
    },
  };
};

export default withStyles((theme) => ({
  wrapper: {
    padding: theme.spacing(4, 2),
    margin: '0 auto',
    maxWidth: 1360,
    width: '100%',
  },
  searchArea: {
    padding: theme.spacing(0, 0, 2),
  },
  container: {
    margin: 'auto',
    padding: theme.spacing(1),
    maxWidth: 300,
  },
  filtersArea: {
    '& > *': {
      margin: '0 8px 20px 0',
    },
  },
  placesTypography: {
    '& input': {
      padding: '10px',
      fontSize: '16px',
      boxSizing: 'border-box',
      width: '100%',
      color: theme.palette.primary.dark,
    },
    '& > *': {
      zIndex: 1000,
    },
  },
  searchInput: {
    padding: '10px',
    fontSize: '16px',
    boxSizing: 'border-box',
    width: '100%',
    color: theme.palette.primary.dark,
  },
  navCategory: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(0, 0, 2),
  },

  infoiconsHolder: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(0, 0, 2),
  },

  infoiconItem: {
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.background.paper,

    '& > [type="checkbox"]:not(:checked)': {
      position: 'absolute',
      left: '-9999px',
    },
    '& > [type="checkbox"]:checked ': {
      position: 'absolute',
      left: '-9999px',
    },

    '& > [type="checkbox"]:not(:checked) + label': {
      position: 'relative',
      cursor: 'pointer',
      fontWeight: '400',
      display: 'flex',
      alignItems: 'center',
    },

    '& > [type="checkbox"]:checked + label': {
      color: theme.palette.primary.main,
    },

    '& > label:hover': {
      color: theme.palette.primary.main,
    },

    '& > label span': {
      display: 'block',
      marginRight: '26px',
    },
  },
  noteSm: {
    margin: theme.spacing(0, 0, 0, 7),
    fontSize: '10px',

    '& > a': {
      color: theme.palette.primary.main,
    },
  },
  viewChangeArea: {
    marginBottom: theme.spacing(2),
  },

  icon: {
    width: '28px',
    height: '28px',
    display: 'block',
  },
  itemCard: {
    minHeight: '100%',
    display: 'flex',
  },
  cardArea: {
    minHeight: '100%',
    position: 'relative',
    paddingBottom: theme.spacing(6),
  },
  cardContent: {
    padding: theme.spacing(2, 2, 1),
  },
  media: {
    height: 100,
    maxWidth: 160,
    backgroundSize: 'contain',
    margin: '20px auto 0',
  },
  infoIcons: {
    margin: 0,
    padding: theme.spacing(1, 2),
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',

    '& > li': {
      marginRight: theme.spacing(1),
    },
  },
  promoIcons: {
    margin: 0,
    padding: theme.spacing(1, 2),
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    position: 'absolute',
    top: '0',
    right: '0',

    '& > li': {
      marginBottom: theme.spacing(1),
    },
  },
  address: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',

    '& > svg': {
      fontSize: '1rem',
    },
    '& > span': {
      fontSize: '12px',
    },
  },
  popover: {
    pointerEvents: 'none',
  },
  headerRate: {
    margin: 0,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: '12px',
    lineHeight: '20px',
    padding: theme.spacing(0.5, 1),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.light,
    borderRadius: '6px',
    position: 'absolute',
    top: theme.spacing(1.3),
    left: theme.spacing(1.3),
  },
  ratingValue: {
    fontSize: '14px',
  },
  section: {
    paddingBottom: theme.spacing(6),
  },
  sectionRegions: {
    padding: theme.spacing(6, 0, 4),
  },
  drawerPaper: {
    width: 300,
  },
  regions: {
    padding: theme.spacing(0, 0, 2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',

    '& > strong': {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },

    '& > strong svg': {
      height: 12,
      width: 12,
      marginRight: theme.spacing(1),
    },

    '& > ul': {
      margin: 0,
      padding: theme.spacing(0, 0, 0, 1),
      listStyle: 'none',
    },

    '& > ul > li': {
      display: 'inline-block',
      content: '&bull;',
    },

    '& > ul > li span': {
      display: 'inline-block',
      padding: theme.spacing(0, 1),
    },

    '& > ul > li:last-child span': {
      display: 'none',
    },

    '& > ul a': {
      textDecoration: 'none',
      color: theme.palette.primary.main,
    },
    '& > ul a:hover': {
      textDecoration: 'underline',
    },
  },
}))(compose(connect(mapStateToProps, mapDispatchToProps), GoogleMapsLoader)(SearchView));
